// extracted by mini-css-extract-plugin
export default {"root":"Lw9aue","container":"plBNLt","text":"jmOuW1","block":"mCurv8"};